module.exports = __webpack_public_path__ + "img/0220805141915.78a46fb2.jpg";